<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import PostSaleCasesTableCorrectionIcons from './PostSaleCasesTableCorrectionIcons.vue';
import PostSaleCasesTableTags from './PostSaleCasesTableTags.vue';
import {
  elapsedPostSaleDays,
  elapsedPostSaleDaysClass,
  formatPostSaleDate,
} from './postSaleCasesTablePresenter';

const props = defineProps({
  item: { type: Object, required: true },
});

const { t } = useI18n();

const elapsedDays = computed(() =>
  elapsedPostSaleDays(props.item.table?.signature_date)
);
const requestDate = computed(
  () => props.item.table?.review_requested_at || props.item.review_requested_at
);
</script>

<template>
  <td class="p-3 align-top">
    {{
      formatPostSaleDate(item.table?.signature_date) ||
      t('POST_SALE.COMMON.NO_DATE')
    }}
  </td>
  <td class="p-3 align-top">
    <p>
      {{ formatPostSaleDate(requestDate) || t('POST_SALE.COMMON.NO_DATE') }}
    </p>
    <span class="text-xs text-lais-text-muted">
      {{
        item.responsible?.name
          ? t('POST_SALE.TABLE.REQUESTED_BY', { name: item.responsible.name })
          : t('POST_SALE.COMMON.UNASSIGNED')
      }}
    </span>
  </td>
  <td
    class="p-3 text-center text-lg font-semibold"
    :class="elapsedPostSaleDaysClass(elapsedDays)"
  >
    {{ elapsedDays }}
  </td>
  <td class="p-3 align-top">
    <PostSaleCasesTableCorrectionIcons :corrections="item.table?.corrections" />
  </td>
  <td class="p-3 align-top">
    <PostSaleCasesTableTags :items="item.table?.laudemiums" type="laudemiums" />
  </td>
  <td class="p-3 align-top">
    <span
      class="rounded-full bg-lais-bg-soft px-2 py-1 text-xs font-semibold text-lais-text-body"
    >
      {{ item.manager?.name || t('POST_SALE.COMMON.UNASSIGNED') }}
    </span>
  </td>
</template>
